import styled from "styled-components";
import { theme } from "styles/theme";
const StyledHeaderNav = styled.div`
  flex-grow: 1;
  max-width: calc(100% - 250px);
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: flex-start;
  .header__wrap-item {
    text-decoration: none;
    transition: 0.4s;
    display: flex;
    flex-wrap: nowrap;
    color: #ccc;
    font-size: 15px;
    align-items: center;
    margin-right: 25px;
    p {
      margin-left: 7px;
      font-size: 12px;
    }
    &:hover {
      .icon {
        color: ${theme.colors.secondary[900]};
        transition: 0.25s;
      }
      p {
        color: ${theme.colors.secondary[900]};
        transition: 0.25s;
      }
    }
  }
`;
export default StyledHeaderNav;
